/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_PhoneInputs */

const en_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const es_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teléfono`)
};

const de_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const zh_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电话`)
};

const ar_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهاتف`)
};

const fr_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphone`)
};

const vi_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điện thoại`)
};

const sw_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simu`)
};

const th_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โทรศัพท์`)
};

const bs_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const ja_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電話番号`)
};

const ko_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전화`)
};

const pt_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefone`)
};

const it_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefono`)
};

const sv_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const nl_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefoon`)
};

const da_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const nb_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const fi_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puhelin`)
};

const pl_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const ru_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телефон`)
};

const tr_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const hi_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोन`)
};

const id_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telepon`)
};

const ms_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const cs_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

const el_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τηλέφωνο`)
};

const he_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טלפון`)
};

const af_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefoon`)
};

const hu_contact_phone = /** @type {(inputs: Contact_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Contact_PhoneInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_phone = /** @type {((inputs?: Contact_PhoneInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_PhoneInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_phone(inputs)
	if (locale === "de") return de_contact_phone(inputs)
	if (locale === "zh") return zh_contact_phone(inputs)
	if (locale === "ar") return ar_contact_phone(inputs)
	if (locale === "fr") return fr_contact_phone(inputs)
	if (locale === "vi") return vi_contact_phone(inputs)
	if (locale === "sw") return sw_contact_phone(inputs)
	if (locale === "th") return th_contact_phone(inputs)
	if (locale === "bs") return bs_contact_phone(inputs)
	if (locale === "ja") return ja_contact_phone(inputs)
	if (locale === "ko") return ko_contact_phone(inputs)
	if (locale === "pt") return pt_contact_phone(inputs)
	if (locale === "it") return it_contact_phone(inputs)
	if (locale === "sv") return sv_contact_phone(inputs)
	if (locale === "nl") return nl_contact_phone(inputs)
	if (locale === "da") return da_contact_phone(inputs)
	if (locale === "nb") return nb_contact_phone(inputs)
	if (locale === "fi") return fi_contact_phone(inputs)
	if (locale === "pl") return pl_contact_phone(inputs)
	if (locale === "ru") return ru_contact_phone(inputs)
	if (locale === "tr") return tr_contact_phone(inputs)
	if (locale === "hi") return hi_contact_phone(inputs)
	if (locale === "id") return id_contact_phone(inputs)
	if (locale === "ms") return ms_contact_phone(inputs)
	if (locale === "cs") return cs_contact_phone(inputs)
	if (locale === "el") return el_contact_phone(inputs)
	if (locale === "he") return he_contact_phone(inputs)
	if (locale === "af") return af_contact_phone(inputs)
	if (locale === "hu") return hu_contact_phone(inputs)
	return en_contact_phone(inputs)
});